import Vue from "vue";
import VueRouter from "vue-router";
import RouteObjects from "@/shared/router/route-objects";

var router = {};

if (window.location.host.match(/admin.*\.penchecks\.com/g) !== null) {
  Vue.use(VueRouter);

  const routes = [
    {
      path: "/",
      name: "Home",
      component: () => import("../views/PcAdminHome.vue"),
    },

    {
      comment: "***** ACCOUNTS *****",
      path: "/accounts",
      name: "Accounts",
      meta: { title: "Accounts" },
      component: () => import("../views/accounts/PcSearchAccounts.vue"),
    },
    {
      path: "/accounts/:accountUuid",
      name: "AccountDetails",
      meta: { title: "Account Details" },
      component: () => import("../views/accounts/PcAccountDetails.vue"),
    },
    {
      path: "/accounts/:accountUuid/tax-forms",
      name: "AccountDetailsTaxForms",
      meta: { title: "Tax Forms" },
      component: () => import("../views/accounts/PcAccountDetails.vue"),
    },
    {
      path: "/accounts/:accountUuid/tax-forms/:taxFormSearchUuid([a-zA-Z0-9]{32})",
      name: "AccountDetailsTaxFormsDownload",
      meta: { title: "Download Tax Forms" },
      component: () => import("../views/accounts/PcAccountDetails.vue"),
    },
    {
      path: "/accounts/:accountUuid/bulk-orders/:bulkOrderUuid",
      name: "BulkOrderSummary",
      meta: { title: "Bulk Order Summary" },
      component: () => import("../views/accounts/PcAccountDetails.vue"),
    },

    {
      path: "/users",
      name: "Users",
      meta: { title: "Search Users" },
      component: () => import("../views/users/PcSearchUsers.vue"),
    },
    {
      path: "/users/:userUuid",
      name: "UserDetails",
      meta: { title: "User Details" },
      component: () => import("../views/users/PcUserDetails.vue"),
    },

    {
      path: "/participants",
      name: "Participants",
      meta: { title: "Search Participants" },
      component: () => import("../views/participants/PcSearchParticipants.vue"),
    },
    {
      path: "/participants/:participantUuid",
      name: "ParticipantDetails",
      meta: { title: "Participant Details" },
      component: () => import("../views/participants/PcParticipantDetails.vue"),
    },

    {
      path: "/plans",
      name: "Plans",
      meta: { title: "Plans" },
      component: () => import("../views/plans/PcSearchPlans.vue"),
    },
    {
      path: "/plans/:planUuid",
      name: "PlanDetails",
      meta: { title: "Plan Details" },
      component: () => import("../views/plans/PcPlanDetails.vue"),
    },
    {
      path: "/plans/:planUuid/tax-forms",
      name: "PlanDetailsTaxForms",
      meta: { title: "Tax Forms" },
      component: () => import("../views/plans/PcPlanDetails.vue"),
    },
    {
      path: "/plans/:planUuid/tax-forms/:taxFormSearchUuid([a-zA-Z0-9]{32})",
      name: "PlanDetailsTaxFormsDownload",
      meta: { title: "Download Tax Forms" },
      component: () => import("../views/plans/PcPlanDetails.vue"),
    },
    {
      path: "/national-registry-accounts",
      name: "NationalRegistryAccounts",
      meta: { title: "National Registry Accounts" },
      component: () =>
        import("../views/national-registry/PcSearchNationalRegistryAccounts.vue"),
    },
    {
      path: "/national-registry/accounts/:nationalRegistryAccountUuid",
      name: "NationalRegistryAccountDetails",
      meta: { title: "National Registry Account Details" },
      component: () =>
        import("../views/national-registry/PcNationalRegistryAccountDetails.vue"),
    },
    {
      path: "/national-registry/contact-us",
      name: "NationalRegistryContactUs",
      meta: { title: "National Registry Contact Us" },
      component: () =>
        import("../views/national-registry/PcNationalRegistryContactUs.vue"),
    },
    {
      comment: "***** NEXTLEVEL IRA *****",
      path: "/next-level-accounts",
      name: "NextLevelAccounts",
      meta: { title: "NextLevel Accounts" },
      component: () =>
        import("../views/next-level-ira/PcNextLevelAccounts.vue"),
    },
    {
      comment: "***** NEXTLEVEL IRA *****",
      path: "/account-holders",
      name: "AccountHolders",
      meta: { title: "Account Holders" },
      component: () => import("../views/next-level-ira/PcNextLevelAccountHolders.vue"),
    },
    {
      path: "/b2b-users",
      name: "B2BUsers",
      meta: { title: "B2B Users" },
      component: () => import("../views/next-level-ira/PcB2BUsers.vue"),
    },
    /**
     * B2B User Hierarchy
     */
    {
      path: "/b2b-users/:accountUuid([a-zA-Z0-9]{32})",
      name: "B2BUserAdvisorHierarchy",
      meta: { title: "B2B User Advisor Hierarchy" },
      component: () =>
        import("../views/next-level-ira/PcB2BUserAdvisorHierarchy.vue"),
    },
    {
      path: "/b2b-user-details/:userUuid([a-zA-Z0-9]{32})",
      name: "B2BUserDetails",
      meta: { title: "User Details" },
      component: () => import("../views/users/PcUserDetails.vue"),
    },
    {
      path: "/b2b-user-campaigns/:campaignUuid([a-zA-Z0-9]{32})",
      name: "B2BUserCampaign",
      meta: { title: "B2B User Campaign" },
      component: () => import("../views/next-level-ira/PcB2BUserCampaign.vue"),
    },
    {
      path: "/b2b-user-campaign-prospects/:prospectUuid([a-zA-Z0-9]{32})",
      name: "B2BUserCampaignProspect",
      meta: { title: "B2B User Campaign Prospect" },
      component: () =>
        import("../views/next-level-ira/PcB2BUserCampaignProspect.vue"),
    },
    {
      path: "/b2b-user-prospects/:prospectUuid([a-zA-Z0-9]{32})",
      name: "B2BUserProspect",
      meta: { title: "B2B User Prospect" },
      component: () => import("../views/next-level-ira/PcB2BUserProspect.vue"),
    },
    {
      path: "/b2b-user-account-holders/:prospectUuid([a-zA-Z0-9]{32})",
      name: "B2BUserAccountHolder",
      meta: { title: "B2B User Account Holder" },
      component: () =>
        import("../views/next-level-ira/PcB2BUserAccountHolder.vue"),
    },
    /**
     * B2B Accounts
     */
    {
      path: "/b2b-accounts",
      name: "B2BAccounts",
      meta: { title: "B2B Accounts" },
      component: () => import("../views/next-level-ira/PcB2BAccounts.vue"),
    },
    {
      path: "/b2b-accounts/:accountUuid([a-zA-Z0-9]{32})",
      name: "B2BAccountDetails",
      meta: { title: "Account Details" },
      component: () => import("../views/accounts/PcAccountDetails.vue"),
    },
    {
      path: "/nl-ira-plans",
      name: "NlIraPlans",
      meta: { title: "NL IRA Plans" },
      component: () => import("../views/next-level-ira/PcNlIraPlans.vue"),
    },
    {
      path: "/next-level-ira/nl-ria-fee-schedules",
      name: "NlRiaFeeSchedules",
      meta: { title: "NL RIA Fee Schedules" },
      component: () =>
        import("../views/next-level-ira/PcNlIraRiaFeeSchedules.vue"),
    },
    {
      path: "/campaigns",
      name: "Campaigns",
      meta: { title: "Campaigns" },
      component: () => import("../views/next-level-ira/PcCampaigns.vue"),
    },
    {
      path: "/campaigns/:campaignUuid([a-zA-Z0-9]{32})",
      name: "CampaignDetails",
      meta: { title: "Campaign Details" },
      component: () => import("../views/next-level-ira/PcCampaignDetails.vue"),
    },
    {
      path: "/campaign-prospects/:prospectUuid([a-zA-Z0-9]{32})",
      name: "CampaignProspect",
      meta: { title: "Campaign Prospect" },
      component: () =>
        import("../views/next-level-ira/PcCampaignProspectDetails.vue"),
    },
    {
      path: "/prospects",
      name: "Prospects",
      meta: { title: "Prospects" },
      component: () => import("../views/next-level-ira/PcProspects.vue"),
    },
    {
      path: "/prospects/:prospectUuid([a-zA-Z0-9]{32})",
      name: "ProspectDetails",
      meta: { title: "Prospect Details" },
      component: () => import("../views/next-level-ira/PcProspectDetails.vue"),
    },
    {
      path: "/next-level-ira/order-lines",
      name: "NextLevelIraOrderLines",
      meta: { title: "Order Lines" },
      component: () => import("../views/next-level-ira/PcNlIraOrderLines.vue"),
    },
    {
      path: "/next-level-ira/payment-instructions",
      name: "NextLevelIraPaymentInstructions",
      meta: { title: "Payment Instructions" },
      component: () =>
        import("../views/next-level-ira/PcNlIraPaymentInstructions.vue"),
    },
    {
      path: "/next-level-ira/content-management",
      name: "NextLevelIraContentManagement",
      meta: { title: "Content Management" },
      component: () =>
        import("../views/next-level-ira/PcNlIraContentManagement.vue"),
    },
    {
      path: "/invoices/:invoiceUuid",
      name: "InvoiceDetails",
      meta: { title: "Invoice Details" },
      component: () => import("../views/plans/PcInvoiceDetails.vue"),
    },

    {
      comment: "***** ORDERS *****",
      path: "/orders",
      name: "Orders",
      meta: { title: "Orders" },
      component: () => import("../views/orders/PcSearchOrders.vue"),
    },
    {
      path: "/orders/:orderUuid",
      name: "OrderDetails",
      meta: { title: "Order Details" },
      component: () => import("../views/orders/PcOrderDetails.vue"),
    },
    {
      path: "/:accountUuid/orders/:orderUuid",
      meta: { title: "Edit Order" },
      component: () => import("../views/orders/PcOrderDetails.vue"),
    },
    {
      path: "/order-lines",
      name: "Order Lines",
      meta: { title: "Order Lines" },
      component: () => import("../views/orders/PcSearchOrderLines.vue"),
    },
    {
      path: "/order-lines/:orderLineUuid",
      name: "OrderLineDetails",
      meta: { title: "Order Line Details" },
      component: () => import("../views/orders/PcOrderLineDetails.vue"),
    },
    {
      path: "/order-lines/:orderLineUuid/tax-forms",
      name: "OrderLineDetailsTaxForms",
      meta: { title: "Tax Forms" },
      component: () => import("../views/orders/PcOrderLineDetails.vue"),
    },
    {
      path: "/recurring-order-lines",
      name: "Recurring Order Lines",
      meta: { title: "Recurring Order Lines" },
      component: () =>
        import("../views/orders/PcSearchRecurringOrderLines.vue"),
    },

    {
      path: "/payment-instructions",
      name: "PaymentInstructions",
      meta: { title: "Payment Instructions" },
      component: () =>
        import("../views/payments/PcSearchPaymentInstructions.vue"),
    },

    {
      path: "/payments",
      name: "Payments",
      meta: { title: "Payments" },
      component: () => import("../views/payments/PcSearchPayments.vue"),
    },
    {
      path: "/payments/:paymentUuid",
      name: "PaymentDetails",
      meta: { title: "Payment Details" },
      component: () => import("../views/payments/PcPaymentDetails.vue"),
    },

    {
      comment: "***** OPERATIONS/TRUST DEPT *****",
      path: "/trust/home",
      name: "TrustDepartment",
      meta: { title: "Trust Department" },
      component: () =>
        import("../views/trust-department/PcTrustDepartment.vue"),
    },
    {
      path: "/trust/orders-to-associate",
      name: "TrustOrdersToAssociate",
      meta: { title: "Orders to Associate" },
      component: () =>
        import("../views/trust-department/PcTrustDepartment.vue"),
    },
    {
      path: "/trust/deposits",
      name: "TrustDeposits",
      meta: { title: "Deposits" },
      component: () =>
        import("../views/trust-department/PcTrustDepartment.vue"),
    },
    {
      path: "/trust/deposits/:depositUuid",
      name: "TrustDeposit",
      meta: { title: "Deposit Details" },
      component: () =>
        import("../views/trust-department/PcTrustDepartment.vue"),
    },
    {
      path: "/deposit-links",
      name: "Deposit Links",
      meta: { title: "Deposit Links to Plan" },
      component: () => import("../views/PcSearchDepositLinks.vue"),
    },
    {
      path: "/deposit-links-to-order",
      name: "Deposit Links to Order",
      meta: { title: "Deposit Links to Order" },
      component: () => import("../views/PcSearchDepositLinks.vue"),
    },
    {
      path: "/deposit-links-to-order-line",
      name: "Deposit Links to Order Line",
      meta: { title: "Deposit Links to Order Line" },
      component: () => import("../views/PcSearchDepositLinks.vue"),
    },
    {
      path: "/trust/payment-instructions-to-review",
      name: "TrustPaymentInstructionsToReview",
      meta: { title: "Trust Payment Instructions" },
      component: () =>
        import("../views/trust-department/PcTrustDepartment.vue"),
    },
    {
      path: "/trust/bank-transactions",
      name: "BankTransactions",
      meta: { title: "Bank Transactions" },
      component: () =>
        import("../views/trust-department/PcTrustDepartment.vue"),
    },
    {
      path: "/trust/bank-transaction-files",
      name: "BankTransactionFiles",
      meta: { title: "Bank Transaction Files" },
      component: () =>
        import("../views/trust-department/PcTrustDepartment.vue"),
    },
    {
      path: "/trust/upload-deposits",
      name: "UploadDeposits",
      meta: { title: "Upload Deposits" },
      component: () =>
        import("../views/trust-department/PcTrustDepartment.vue"),
    },
    {
      path: "/trust/john-hancock",
      name: "JohnHancock",
      meta: { title: "John Hancock" },
      component: () =>
        import("../views/trust-department/PcTrustDepartment.vue"),
    },

    {
      path: "/trust/associations/home",
      name: "Associations",
      meta: { title: "Associations" },
      component: () =>
        import("../views/trust-department/PcTrustAssociations.vue"),
    },
    {
      path: "/trust/associations/rbp",
      name: "RbpAssociations",
      meta: { title: "RBP Associations" },
      component: () =>
        import("../views/trust-department/PcTrustAssociations.vue"),
    },
    {
      path: "/trust/associations/:linkOrCredit(links|credit)/:type(plans|accounts|orders|order-lines)",
      name: "Associations Search",
      meta: { title: "Associations Search" },
      component: () =>
        import("../views/trust-department/PcTrustAssociations.vue"),
    },

    {
      path: "/auto-service",
      name: "Custodian Auto Service",
      meta: { title: "Custodian Auto Service" },
      component: () =>
        import("../views/auto-service/PcCustodianAutoService.vue"),
    },

    {
      comment: "***** OPERATIONS/DISTRIBUTIONS DEPT *****",
      path: "/distributions",
      name: "DistributionsDepartment",
      meta: { title: "Distributions Department" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },
    {
      path: "/distributions/orders-to-initiate",
      name: "OrdersToInitiate",
      meta: { title: "Orders to Initiate" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },
    {
      path: "/distributions/payment-instructions-ready-to-pay",
      name: "PaymentInstructionsReadyToPay",
      meta: { title: "Payments Ready to Pay" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },

    {
      path: "/payment-batches",
      name: "PaymentBatches",
      meta: { title: "Payment Batches" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },
    {
      path: "/payment-batches/:paymentBatchUuid",
      name: "PaymentBatchDetails",
      meta: { title: "Payment Batch Details" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },

    {
      path: "/distributions/missing-notices",
      name: "MissingNotices",
      meta: { title: "Missing Notices" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },
    {
      path: "/distributions/supplement-document-reviews",
      name: "SupplementDocumentReviews",
      meta: { title: "Supplemental Documents" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },
    {
      path: "/distributions/documents-ready-to-send",
      name: "OrderLineDocuments",
      meta: { title: "Documents Ready to Send" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },
    {
      path: "/document-batches",
      name: "DocumentBatches",
      meta: { title: "Document Batches" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },
    {
      path: "/document-batches/:documentBatchUuid",
      name: "DocumentBatchDetails",
      meta: { title: "Document Batch Details" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },

    {
      path: "/distributions/expired-order-lines",
      name: "ExpiredOrderLines",
      meta: { title: "Expired Order Lines" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },
    {
      path: "/distributions/expired-order-lines-to-follow-up",
      name: "ExpiredOrderLinesToFollowUp",
      meta: { title: "Follow Up on Expired Order Lines" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },

    {
      path: "/distributions/bulk-operations",
      name: "BulkOperations",
      meta: { title: "Bulk Operations" },
      component: () =>
        import("../views/distributions-department/PcDistributionsDepartment.vue"),
    },

    {
      path: "/recurring/home",
      name: "Recurring Benefits",
      meta: { title: "Recurring Benefits" },
      component: () => import("../views/recurring/PcRecurringDepartment"),
    },
    {
      path: "/recurring/plans",
      name: "Recurring Plans",
      meta: { title: "Recurring Plans" },
      component: () => import("../views/recurring/PcRecurringDepartment"),
    },
    {
      path: "/recurring/participants",
      name: "Recurring Participants",
      meta: { title: "Recurring Participants" },
      component: () => import("../views/recurring/PcRecurringDepartment"),
    },
    {
      path: "/recurring/invoices",
      name: "Invoices",
      meta: { title: "Invoices" },
      component: () => import("../views/recurring/PcRecurringDepartment"),
    },
    {
      path: "/recurring/invoices/:invoiceUuid",
      name: "InvoiceDetail",
      meta: { title: "Invoice Detail" },
      component: () => import("../views/recurring/PcRecurringDepartment"),
    },

    {
      path: "/recurring/create-batch",
      name: "CreateRecurringBatch",
      meta: { title: "Create Recurring Batch" },
      component: () => import("../views/recurring/PcRecurringDepartment"),
    },
    {
      path: "/recurring/batches",
      name: "RecurringBatches",
      meta: { title: "Recurring Batches" },
      component: () => import("../views/recurring/PcRecurringDepartment"),
    },
    {
      path: "/recurring/batch-orders",
      name: "RecurringBatchOrders",
      meta: { title: "Recurring Batch Orders" },
      component: () => import("../views/recurring/PcRecurringDepartment"),
    },
    {
      path: "/recurring/batches/:recurringBatchUuid",
      name: "RecurringBatchDetail",
      meta: { title: "Recurring Batch Detail" },
      component: () => import("../views/recurring/PcRecurringDepartment"),
    },

    {
      path: "/accounts-division/order-lines",
      name: "AccountsDivisionOrderLines",
      meta: { title: "Order Lines | Accounts Division" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/accounts-division/duplicate-order-lines",
      name: "AccountsDivisionDuplicateOrderLines",
      meta: { title: "Duplicate Order Lines | Accounts Division" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/accounts-division/plan-ptp-name-change-requests",
      name: "AccountsDivisionPlanPtpNameChangeRequests",
      meta: { title: "Plan PTP Name Change Requests | Accounts Division" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/deposit-batches",
      name: "DepositBatches",
      meta: { title: "Deposit Batches" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/deposit-batches/:depositBatchUuid",
      name: "DepositBatchDetails",
      meta: { title: "Deposit Batch Details" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/accounts-division/next-level-queue",
      name: "AccountsDivisionNextLevelQueue",
      meta: { title: "Next Level Queue | Accounts Division" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/accounts-division/next-level-failed-queue",
      name: "AccountsDivisionNextLevelFailedQueue",
      meta: { title: "Next Level Failed Queue | Accounts Division" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/accounts-division/next-level-queue-advisor",
      name: "AccountsDivisionNextLevelQueueAdvisor",
      meta: {
        title: "Next Level Customer Identification Program | Accounts Division",
      },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/accounts-division/order-line-documents",
      name: "AccountsDivisionDocuments",
      meta: { title: "Documents | Accounts Division" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/accounts-division/document-batches",
      name: "AccountsDivisionDocumentBatch",
      meta: { title: "Document Batches | Accounts Division" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },
    {
      path: "/accounts-division/document-batches/:documentBatchUuid",
      name: "AccountsDivisionDocumentBatchDetail",
      meta: { title: "Document Batch Detail | Accounts Division" },
      component: () =>
        import("../views/accounts-division/PcAccountsDivision.vue"),
    },

    {
      path: "/taxes-payable",
      name: "TaxesPayable",
      meta: { title: "Federal & State Tax Remittance" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/order-line-taxes",
      name: "OrderLineTaxes",
      meta: { title: "Order Line Taxes" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/tax-payments",
      name: "TaxPayments",
      meta: { title: "Tax Payments" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/tax-payment-batches",
      name: "TaxPaymentBatches",
      meta: { title: "Tax Payment Batches" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/tax-payment-batches/:taxPaymentBatchUuid",
      name: "TaxPaymentBatchDetails",
      meta: { title: "Tax Payment Batch Details" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/tax-refunds",
      name: "TaxRefunds",
      meta: { title: "Tax Refunds" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/tax-refunds/:taxRefundUuid",
      name: "TaxRefundsDetails",
      meta: { title: "TaxRefunds Details" },
      component: () => import("../views/taxes-and-fees/PcTaxRefundDetails.vue"),
    },
    {
      path: "/state-tax-rates",
      name: "StateTaxRates",
      meta: { title: "State Tax Rates" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/tax-reporting-change-request-queue",
      name: "TaxReportingChangeRequestQueue",
      meta: { title: "1099 Change Request Queue" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/taxing-authority/:authorityId",
      name: "TaxingAuthorityHome",
      meta: { title: "Taxing Authority Home" },
      component: () =>
        import("../views/taxes-and-fees/PcTaxingAuthorityHome.vue"),
    },
    {
      path: "/irs-form-reporting",
      name: "IRS Form Reporting",
      meta: { title: "IRS Form Reporting" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/irs-form-archive",
      name: "IRS Form Archive",
      meta: { title: "IRS Form Archive" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },
    {
      path: "/tax_adjustments_ledger",
      name: "Tax Adjustments Ledger",
      meta: { title: "Tax Adjustments Ledger" },
      component: () => import("../views/taxes-and-fees/PcTaxes.vue"),
    },

    {
      path: "/fees-payable",
      name: "FeesPayable",
      meta: { title: "Fees Payable" },
      component: () => import("../views/taxes-and-fees/PcFees.vue"),
    },
    {
      path: "/order-line-fees",
      name: "OrderLineFees",
      meta: { title: "Order Line Fees" },
      component: () => import("../views/taxes-and-fees/PcFees.vue"),
    },

    {
      comment: "***** LEGAL *****",
      path: "/legal/fincen",
      name: "FinCEN",
      meta: { title: "FinCEN" },
      component: () => import("../views/legal/PcUploadFinCenFile.vue"),
    },

    {
      comment: "***** LEGAL *****",
      path: "/legal/ofac",
      name: "Ofac Results",
      meta: { title: "Ofac Results" },
      component: () => import("../views/legal/PcOfacResults.vue"),
    },

    {
      comment: "***** SYSTEM *****",
      path: "/authorization/staff-members",
      name: "StaffMembers",
      meta: { title: "Staff Members" },
      component: () => import("../views/permissions/PcAuthorization.vue"),
    },
    {
      path: "/authorization/roles",
      name: "Roles",
      meta: { title: "Roles" },
      component: () => import("../views/permissions/PcAuthorization.vue"),
    },
    {
      path: "/authorization/permissions",
      name: "Permissions",
      meta: { title: "Permissions" },
      component: () => import("../views/permissions/PcAuthorization.vue"),
    },

    {
      path: "/agreements",
      name: "Agreements",
      meta: { title: "Agreements" },
      component: () => import("../views/agreements/PcAgreementDetails.vue"),
    },

    {
      path: "/messages",
      name: "Messages",
      meta: { title: "Messages" },
      component: () => import("../views/messages/PcSearchMessages.vue"),
    },
    {
      path: "/messages/:messageUuid",
      name: "MessageDetails",
      meta: { title: "Message Details" },
      component: () => import("../views/messages/PcMessageDetails.vue"),
    },

    {
      path: "/rules-engine",
      name: "Rules Engine",
      meta: { title: "Rules Engine" },
      component: () => import("../views/rules-engine/PcRulesEngine.vue"),
    },
    {
      path: "/notice-management/:category",
      name: "Add Notice",
      meta: { title: "Add Notice" },
      component: () =>
        import("../views/content-management/notices/PcNoticeDetails.vue"),
    },
    {
      path: "/content-management",
      name: "Content Management",
      meta: { title: "Content Management" },
      component: () =>
        import("../views/content-management/PcContentManagement.vue"),
      children: [
        {
          path: "notices",
          name: "Notices",
          meta: { title: "Content Management - Notices" },
          component: () =>
            import("../views/content-management/notices/PcNoticeManagement.vue"),
        },
        {
          path: "user-guides",
          name: "User Guides",
          meta: { title: "Content Management - User Guides" },
          component: () =>
            import("../views/content-management/user-guides/PcUserGuideManagement.vue"),
        },
        {
          path: "float-disclosure",
          name: "Float Disclosure",
          meta: { title: "Content Management - Float Disclosure" },
          component: () =>
            import("../views/content-management/float-disclosure/PcFloatDisclosureManagement.vue"),
        },
      ],
    },
    {
      path: "/system-properties",
      name: "System Properties",
      meta: { title: "System Properties" },
      component: () =>
        import("../views/system-properties/PcSystemProperties.vue"),
    },
    {
      path: "/saved-searches",
      name: "Saved Searches",
      meta: { title: "Saved Searches" },
      component: () => import("../views/saved-searches/PcSavedSearches.vue"),
    },
    {
      path: "/ui-components",
      name: "UI Components",
      meta: { title: "UI Components" },
      component: () =>
        import("../views/ui-components/PcUiComponentDetails.vue"),
    },
    {
      path: "/technology-team",
      name: "Technology Team",
      meta: { title: "Technology Team" },
      component: () =>
        import("../views/technology-department/PcTechnologyDepartment.vue"),
    },

    {
      path: "/feature-flags",
      name: "Feature Flags",
      meta: { title: "Feature Flags" },
      component: () => import("../views/feature-flags/PcFeatureFlags.vue"),
    },

    {
      comment: "***** GENERAL *****",
      path: "/files/:storedFileUuid([a-zA-Z0-9]{32})/download",
      meta: { title: "File Download" },
      component: () => import("../views/PcAdminFileDownload.vue"),
    },

    // Keep this last for 404s
    {
      path: "/*",
      name: "NotFound",
      meta: { title: "404 Not Found" },
      component: () => import("../views/Pc404NotFound.vue"),
    },
  ];

  router = new VueRouter({
    mode: "history",
    routes,
  });

  router.objects = new RouteObjects(router);

  router.afterEach((to) => {
    if (to.meta && to.meta.title) {
      document.title = to.meta.title + " | PenChecks Admin";
    } else {
      document.title = "PenChecks Admin";
    }

    if (router.app && router.app.$gtag) {
      router.app.$gtag.pageview({
        page_title: document.title,
        page_path: to.path,
        page_location: window.location.href,
      });
    }
  });
}

export default router;
